module.exports = __webpack_public_path__ + "static/media/composition.js.3be7cb2c.map";